import { render, staticRenderFns } from "./contentSecurity.vue?vue&type=template&id=aa84a1d2&scoped=true&"
import script from "./contentSecurity.vue?vue&type=script&lang=js&"
export * from "./contentSecurity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa84a1d2",
  null
  
)

export default component.exports